import './index.css';
import { GoogleTagManager } from '@iwoca/frontend-tracking-library';
import ReactDOM from 'react-dom';

import App from './App';

GoogleTagManager.initialize({
    customerJourney: 'Account pages',
    trackWithDataAttribute: true
});

ReactDOM.render(<App />, document.getElementById('root'));
